function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9c22e;stroke:#1c0f13;}.cls-1,.cls-14,.cls-15{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:square;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-width:0.32px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-10,.cls-11,.cls-12,.cls-13,.cls-8,.cls-9{stroke-width:0.32px;}.cls-8{fill:url(#radial-gradient);}.cls-9{fill-opacity:0.42;fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11,.cls-12{opacity:0.5;isolation:isolate;}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:#d8dbe2;}.cls-14,.cls-15{stroke-width:0.1px;}.cls-15{fill:#f6e8ea;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -241.33,
  y1: 714.89,
  x2: -231.58,
  y2: 714.89,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#5b3419"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#8d5027"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#8a4d26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#804222"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#6f311c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#571814"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#541513"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -241.35,
  y1: 714.93,
  x2: -231.97,
  y2: 714.93,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -247.52,
  y1: 721.4,
  x2: -240.7,
  y2: 721.4,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#ebc17d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#dfb77c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#c08329"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#eabe81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eedcc3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -188.07,
  y1: 715.05,
  x2: -178.37,
  y2: 715.05,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -181.72,
  y1: 714.27,
  x2: -185.05,
  y2: 716.2,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: -179.01,
  y1: 721.6,
  x2: -172.19,
  y2: 721.6,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: -210.27,
  cy: 717.78,
  r: 7.76,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fffbcc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#fbf2bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#f0d98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#eed688"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ebbb10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c3922e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: -220.76,
  y1: 717.32,
  x2: -199.4,
  y2: 717.32,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fdebf3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#f7eaf3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#faf1f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#fffef0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fbfbf0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#f0f3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#dde5f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#dce4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fee9df"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: -181.02,
  y1: 701.43,
  x2: -241.43,
  y2: 736.31,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: -219.17,
  y1: 712.13,
  x2: -243.01,
  y2: 725.9,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d6e5e5",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#ededee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#e9eee7",
  stopOpacity: 0.77
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#e2efdd",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#e7f2df",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#f4f8e2",
  stopOpacity: 0.77
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#fcfce4",
  stopOpacity: 0.94
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#fffde5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#cee3e6",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: -176.49,
  y1: 711.14,
  x2: -204.25,
  y2: 727.17,
  xlinkHref: "#linear-gradient-9"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: -210.13,
  y1: 725.67,
  x2: -210.13,
  y2: 721.87,
  gradientTransform: "matrix(1, 0, 0, -1, 287, 743.79)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e4a324"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#e7b141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#eabf5c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#edc972"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#efd283"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#f0d88e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#f1db95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#f1dc97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#f0da96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#ebd391"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#e3c888"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#d8b77c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#c9a16d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#b78559"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#a26542"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#894129"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#772515"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_4",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M116.63,1.58h34.78V12.52H134.13v9H149.9V30.6H134.13v9.57h17.28V51.12H116.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M168.83,1.58h21.89l14.33,49.54H188.13l-1.87-9.51H173.44l-2.09,9.51h-16.2Zm15.7,31.18-4.68-21.68L175,32.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M213.91,12.52h-10.3V1.58H241V12.52h-10.3v38.6H213.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253.43,1.58h21.89l14.33,49.54H272.73l-1.87-9.51H258L256,51.12h-16.2Zm15.7,31.18-4.68-21.68-4.9,21.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M294.4,1.58H310V40.17h17.21V51.12H294.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M343,49.53A20.4,20.4,0,0,1,331.19,30.6v-29h16.27v29q0,4.32,2.09,6.48t6.12,2.16a8.06,8.06,0,0,0,6.12-2.2q2.08-2.19,2.09-6.44v-29h16.27v29a20.36,20.36,0,0,1-11.77,18.93,30.85,30.85,0,0,1-25.42,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M387.28,48.52l3.6-11.16A39.67,39.67,0,0,0,404.13,40a10.59,10.59,0,0,0,4.64-.76A2.42,2.42,0,0,0,410.25,37a2.38,2.38,0,0,0-.79-1.76,10.7,10.7,0,0,0-3.17-1.69c-1.59-.63-4-1.39-7.13-2.31a18,18,0,0,1-9.07-5.65,13.77,13.77,0,0,1-3.24-9q0-7.92,5.22-12T406.14.5a42.43,42.43,0,0,1,9.08,1,30.08,30.08,0,0,1,7.92,2.85l-3.89,10.87a60.53,60.53,0,0,0-7-2,28.75,28.75,0,0,0-5.8-.61q-4.76,0-4.75,2.59a2.56,2.56,0,0,0,1.55,2.19,31.84,31.84,0,0,0,6.37,2.27q7.56,2,11.45,6.16a14,14,0,0,1,3.89,9.9q0,8-5.19,12.27t-15.33,4.29Q394.27,52.27,387.28,48.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M.93,48.52l3.6-11.16A39.71,39.71,0,0,0,17.78,40a10.59,10.59,0,0,0,4.64-.76A2.42,2.42,0,0,0,23.9,37a2.35,2.35,0,0,0-.79-1.76,10.7,10.7,0,0,0-3.17-1.69c-1.58-.63-4-1.39-7.13-2.31a18,18,0,0,1-9.07-5.65,13.77,13.77,0,0,1-3.24-9q0-7.92,5.22-12T19.8.5a42.41,42.41,0,0,1,9.07,1,30.08,30.08,0,0,1,7.92,2.85L32.9,15.19a60.53,60.53,0,0,0-7-2,28.68,28.68,0,0,0-5.8-.61c-3.16,0-4.75.86-4.75,2.59a2.58,2.58,0,0,0,1.55,2.19,32.09,32.09,0,0,0,6.37,2.27q7.56,2,11.45,6.16a14,14,0,0,1,3.89,9.9q0,8-5.19,12.27T18.07,52.27Q7.92,52.27.93,48.52Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "ReadingGlasses"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M47.54,24.69a121.34,121.34,0,0,1,7,10c.39.6,1.3-1.17.66-2.33-.45-.57-3.56-4.3-6.28-7.95A8.21,8.21,0,0,0,48,23.5c-1.27-.7-2.09-.71-2.21-.1s-.18.48,0,.58S47,24,47.54,24.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M49.78,27.59a1.3,1.3,0,0,1,0-1.2l.11-.2-.85.24a1.31,1.31,0,0,1,.37-1.31l-.55-.72a11.6,11.6,0,0,0-.92-.95c-1.27-.69-2.1-.71-2.22-.1s-.17.49,0,.59,1.16,0,1.75.7,1.44,1.8,2.26,2.95Zm.27.38c.55.78,1.1,1.59,1.63,2.37a.69.69,0,0,1,.51-.64c.37-.06.73.31.8.81a1,1,0,0,1,0,.24h0c.37-.06.73.31.81.81a1.22,1.22,0,0,1-.06.6,1.1,1.1,0,0,1,.33.65,1.24,1.24,0,0,1,0,.54,1.22,1.22,0,0,1,.19.49,1.18,1.18,0,0,1,0,.46l.24.38c.13.21.33.12.51-.12a1.48,1.48,0,0,1-.25-.31.83.83,0,0,1,.11-1.14l0,0a1.43,1.43,0,0,1-.14-.2.91.91,0,0,1,0-1c-.63-.77-1.84-2.25-3.2-4L51.5,28a1.23,1.23,0,0,1-.71-.67l-.48.83Zm2.33,3.41.92,1.39,0-.15c-.11-.73-.53-1.19-.89-1.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M46.1,23.93l.2-1L40,20.84l-.48,1.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M106.76,24.51a122,122,0,0,0-6.93,10.08c-.39.6-1.32-1.17-.69-2.33.46-.57,3.54-4.32,6.24-8a7,7,0,0,1,.92-1c1.26-.71,2.09-.72,2.21-.12s.18.49,0,.59C108.18,24.05,107.35,23.82,106.76,24.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M104.54,27.43a1.3,1.3,0,0,0-.05-1.2l-.11-.2.86.23a1.32,1.32,0,0,0-.38-1.3l.54-.73a11.6,11.6,0,0,1,.92-.95c1.26-.7,2.09-.72,2.21-.11s.18.49,0,.59c-.33.24-1.16,0-1.75.71s-1.43,1.8-2.24,3Zm-.26.38c-.55.78-1.1,1.59-1.62,2.38a.69.69,0,0,0-.52-.64c-.36-.05-.72.32-.8.82a1.93,1.93,0,0,0,0,.24h0c-.37-.06-.73.31-.8.81a1.11,1.11,0,0,0,.06.6,1.15,1.15,0,0,0-.33.66,1.06,1.06,0,0,0,0,.53,1.28,1.28,0,0,0-.2.5,1.42,1.42,0,0,0,0,.46l-.24.37c-.13.22-.33.13-.51-.11a1.48,1.48,0,0,0,.25-.31A.84.84,0,0,0,99.47,33l0,0a1.43,1.43,0,0,0,.14-.2.91.91,0,0,0,0-1c.62-.78,1.82-2.26,3.17-4l.09.14a1.26,1.26,0,0,0,.7-.68L104,28a1.37,1.37,0,0,0,.26-.2ZM102,31.25l-.9,1.4a1,1,0,0,1,0-.16c.11-.73.52-1.19.88-1.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M108.2,23.75l-.21-1,6.33-2.15.49,1.88-6.61,1.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42.19,1.58h16.2l4.68,31.61L67.89,10H84.67l4.89,23.19L94.24,1.58h16.2L99.21,51.12H82.44L76.32,24.48,70.2,51.12H53.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M84.21,26.22a26.86,26.86,0,0,0-1.81-3A6.22,6.22,0,0,0,81,21.86a3.31,3.31,0,0,0-1.91-.65H74.28a6.48,6.48,0,0,0-1.91.67A5,5,0,0,0,71,23.27c-.53.72-1.78,3-1.78,3L66.86,30.8c.85-.13,1-.13,1.06-.14,2.51-5.24,2.52-5.25,2.52-5.26.31-.49.63-.89.91-1.29a6.57,6.57,0,0,1,3.16-2.32l4.37,0h0c1,.05,2.11.91,3.22,2.31l.9,1.34,2.54,5.21c.59.08.83.1,1.06.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M80.76,23.63a3.06,3.06,0,0,1,.91,1.13l.07.24s2.59,5,4.21,6.8l.07.1,0,.09c0,.26.36.48.77.48s.76-.23.76-.49a17.72,17.72,0,0,0-.67-2.83,16.37,16.37,0,0,0-3-5.53c-1.69-3.13-3.19-3.22-7-3.21h-.26c-3.83,0-5.19.11-6.86,3.25a16.41,16.41,0,0,0-2.93,5.56,17.43,17.43,0,0,0-.65,2.83c0,.26.35.48.76.48s.57-.21.82-.57L72.05,25a4.81,4.81,0,0,1,4.77-3.26l.13,0,.12,0a5.44,5.44,0,0,1,3.69,1.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M115.56,19.71c-.11-.29-3-.36-4-.37-1.08-3.95-3.34-5.68-8.78-6.87a25.15,25.15,0,0,0-5.08-.41H97c-1.46-.26-10-.1-20.15-.06C69.05,12,62.3,11.87,59,11.9c-.43,0-.85,0-1.28,0L56.29,12c-1,.09-2.06.22-3.15.39l-2,.33-.57.11-.21.05c-4.71,1.29-7.13,3.29-8.35,7-1.08,0-3.77.12-3.87.4a4.22,4.22,0,0,0,0,2.46c.14.22,2.12.2,3.18.18l0,.18V28s3.2,10.24,9.75,11.33a26.07,26.07,0,0,0,5.25.4h.22c7.53,0,12.2-5.42,15-14.56.19-.63.53-2.19.72-3.28q0-.32.09-.57l4,0,3.54,0h1.37c0,.2.07.4.11.59,2.08,11.18,7.84,18,16,18a18.75,18.75,0,0,0,2.25-.23l.75-.12,1.37-.24.58-.1c5.94-.94,9.08-3.9,10-9.84a1.93,1.93,0,0,1,0-.27c0-.17.06-.31.1-.48h0s.07-.33.08-.41c.19-.9.15-1.9-.24-5.29,0-.18,0-.36-.07-.54,1,0,3.25.05,3.4-.19A4.23,4.23,0,0,0,115.56,19.71ZM76.84,12.9c3.86,0,7.5-.06,10.61-.13-3.34.77-5.92,3-6.25,5.18h.43l-.16.16-.31.31c0-.1,0-.21,0-.31a.88.88,0,0,1,0-.16h-9c0,.07,0,.12,0,.16l0,.31-.3-.28L71.75,18h.42a5.57,5.57,0,0,0-3.38-4.21,14,14,0,0,0-2.89-1C69.05,12.86,72.81,12.91,76.84,12.9ZM111.55,28c0,.07-.08.36-.09.39h0c0,.19-.07.35-.1.53s0,.19,0,.29c-.8,5.52-3.62,8.17-9.18,9.05l-.58.1-1.35.24-.74.11a19.63,19.63,0,0,1-2.11.23c-7.65,0-13.1-6.46-15.1-17.3l-.15-.86,0-.32h0v-.12c0-.31-.59-.56-1.54-.55H73.24s-1.78.28-1.78.58v.14h0v.38a3.78,3.78,0,0,1-.07.68c-.16,1-.53,2.73-.72,3.35C68,33.71,63.55,38.79,56.5,38.81h-.22a24.25,24.25,0,0,1-5.06-.39C45.15,37.42,42.27,28,42.27,28v-4.8s0,0,0,0v0s2.86-7.91,8.36-9.42l.17,0,.56-.11,1.94-.33c1.07-.16,2.12-.29,3.1-.38l1.34-.09a27.83,27.83,0,0,1,4.47.2c.39,0,.73.1,1,.15l.37.06c4.86.83,7.48,2.14,7.68,5.23V19c0,.31.82.57,1.8.57h7.24c1,0,1.78-.3,1.78-.6v-.14h0v-.56c.15-2.29,3.92-5,8.26-4.83h.08l.62-.06,1.63-.15c1.72-.13,3.44-.22,5-.22a23.86,23.86,0,0,1,4.88.39c6.42,1.41,8,3.41,8.68,9.61C111.67,26.29,111.7,27.22,111.55,28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M71.41,21.56c-.17,1-.53,2.73-.73,3.35C68,33.71,63.55,38.79,56.5,38.82h-.22a25.72,25.72,0,0,1-5.06-.39c-6.08-1-8.93-4.68-8.95-10.42l0-4.8c.79-5.5,2.86-7.91,8.36-9.43l.17,0,.57-.11c.6-.11,1.25-.23,1.93-.33,1.07-.16,2.12-.3,3.1-.38l1.34-.09a27.77,27.77,0,0,1,4.47.19l1.05.15.36.07c4.86.83,7.49,2.13,7.69,5.22v.13a1,1,0,0,0-.13.48v1.84A1,1,0,0,0,71.41,21.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M111.57,28c0,.07-.08.36-.09.39h0c0,.19-.07.35-.1.53s0,.19,0,.29c-.8,5.53-3.62,8.18-9.18,9l-.59.11-1.35.23-.73.12a17.09,17.09,0,0,1-2.12.22c-7.66,0-13.11-6.46-15.1-17.3a1,1,0,0,0,.32-.7V19.09a1,1,0,0,0-.47-.82c.15-2.29,3.91-5,8.26-4.83h.08l.62-.06,1.63-.15c1.72-.13,3.44-.22,5-.22a23.92,23.92,0,0,1,4.88.39c6.42,1.41,8,3.41,8.68,9.61C111.69,26.3,111.73,27.23,111.57,28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M82.58,19.1v1.84a1,1,0,0,1-.32.71,1.13,1.13,0,0,1-.72.27H72.21a1.05,1.05,0,0,1-.8-.36.94.94,0,0,1-.24-.62V19.1a1,1,0,0,1,.76-.94.84.84,0,0,1,.27,0h9.34a1.14,1.14,0,0,1,.57.16A1,1,0,0,1,82.58,19.1Z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M198.22,74.17v4a.71.71,0,0,1-.13.45.41.41,0,0,1-.32.15.42.42,0,0,1-.31-.13.53.53,0,0,1-.16-.37l-.15-1.74h-4V82.3h4.1a.54.54,0,0,1,.4.14.47.47,0,0,1,.14.35.48.48,0,0,1-.14.36.49.49,0,0,1-.39.14H190.1a.6.6,0,0,1-.44-.15.46.46,0,0,1,0-.7.61.61,0,0,1,.42-.14h2V70.58h-1.59a.54.54,0,0,1-.41-.15.46.46,0,0,1-.15-.34.5.5,0,0,1,.16-.37.61.61,0,0,1,.43-.15H201a.68.68,0,0,1,.47.17.58.58,0,0,1,.19.46v3.17a.52.52,0,0,1-.14.38.48.48,0,0,1-.33.13.58.58,0,0,1-.34-.11.47.47,0,0,1-.16-.33l-.16-2.86H193.2v5h4l.15-1.56a.69.69,0,0,1,.16-.39.43.43,0,0,1,.31-.14.42.42,0,0,1,.32.16A.77.77,0,0,1,198.22,74.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M212.35,77.55a3.58,3.58,0,0,0-.53-2.1,2.16,2.16,0,0,0-1.85-.72,7.06,7.06,0,0,0-1.35.12,6.16,6.16,0,0,0-1.24.4,4.89,4.89,0,0,1-.21,1.36.58.58,0,0,1-.56.46.63.63,0,0,1-.52-.23,1,1,0,0,1-.19-.61,1.86,1.86,0,0,1,.52-1.27,3.4,3.4,0,0,1,1.44-.88,6.61,6.61,0,0,1,2.12-.31,3.8,3.8,0,0,1,2.12.5,2.65,2.65,0,0,1,1.07,1.45,7.92,7.92,0,0,1,.31,2.37v3.66a.71.71,0,0,0,.16.55.63.63,0,0,0,.44.15,1.39,1.39,0,0,0,.65-.18,2,2,0,0,0,.54-.39.35.35,0,0,1,.28-.14.37.37,0,0,1,.3.15.48.48,0,0,1,.13.34.44.44,0,0,1-.11.29,2.7,2.7,0,0,1-.87.63,2.37,2.37,0,0,1-1,.23,1.74,1.74,0,0,1-1-.29,1.69,1.69,0,0,1-.55-1.12,4.37,4.37,0,0,1-1.61,1.08,5.76,5.76,0,0,1-2.26.43,2.83,2.83,0,0,1-2.05-.72,2.57,2.57,0,0,1-.73-1.93,2.22,2.22,0,0,1,.77-1.84,4.22,4.22,0,0,1,1.9-.82c.76-.13,1.77-.24,3-.33l.86,0Zm0,3.53V78.59l-.48,0Q210,78.83,209,79a3.49,3.49,0,0,0-1.51.59,1.45,1.45,0,0,0-.57,1.24,1.58,1.58,0,0,0,.49,1.3,1.93,1.93,0,0,0,1.29.4,5.52,5.52,0,0,0,2-.39A4.48,4.48,0,0,0,212.35,81.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M227.82,77a2.4,2.4,0,0,0-.53-1.66,2,2,0,0,0-1.58-.58,4.37,4.37,0,0,0-1.93.41,3.55,3.55,0,0,0-1.34,1A2,2,0,0,0,222,77.4v4.93h1.23a.61.61,0,0,1,.42.14.49.49,0,0,1,.14.33.46.46,0,0,1-.16.35.56.56,0,0,1-.42.14h-3.55a.51.51,0,0,1-.4-.15.47.47,0,0,1-.14-.35.44.44,0,0,1,.13-.32.46.46,0,0,1,.36-.14h1.26V75l-1.26.25a.67.67,0,0,1-.24,0,.41.41,0,0,1-.32-.13.42.42,0,0,1-.13-.32.53.53,0,0,1,.09-.3.46.46,0,0,1,.29-.18l1.93-.38.21,0c.29,0,.44.15.45.46l.06,1.41a3.27,3.27,0,0,1,.87-1A4.44,4.44,0,0,1,224.1,74a4.56,4.56,0,0,1,1.55-.27,3.26,3.26,0,0,1,2.47.85,3.36,3.36,0,0,1,.82,2.43v5.28h1.28a.47.47,0,0,1,.35.14.52.52,0,0,1,.12.33.51.51,0,0,1-.13.35.44.44,0,0,1-.36.14h-4a.5.5,0,0,1-.39-.15.5.5,0,0,1,0-.67.5.5,0,0,1,.37-.14h1.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M237.79,75.18V80.9a1.41,1.41,0,0,0,.56,1.24,2.5,2.5,0,0,0,1.46.39,5.54,5.54,0,0,0,1.7-.28,5.3,5.3,0,0,0,1.45-.71.14.14,0,0,1,.13-.05.46.46,0,0,1,.33.2.6.6,0,0,1,.16.4.27.27,0,0,1-.06.17,2.44,2.44,0,0,1-.85.58,6.75,6.75,0,0,1-1.4.47,7.16,7.16,0,0,1-1.58.18,3.71,3.71,0,0,1-1.49-.3,2.76,2.76,0,0,1-1.12-.8,1.68,1.68,0,0,1-.41-1.08V75.18H235a.54.54,0,0,1-.4-.15.52.52,0,0,1-.14-.35.44.44,0,0,1,.13-.32.49.49,0,0,1,.36-.14h1.73c0-1,0-1.67,0-2.09a2.92,2.92,0,0,1,.18-.94.51.51,0,0,1,.49-.29.37.37,0,0,1,.34.13.81.81,0,0,1,.08.39v2.8h4.36a.4.4,0,0,1,.33.15.48.48,0,0,1,.13.33.45.45,0,0,1-.13.34.4.4,0,0,1-.34.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M255.94,77.55a3.51,3.51,0,0,0-.53-2.1,2.15,2.15,0,0,0-1.85-.72,7.06,7.06,0,0,0-1.35.12,5.88,5.88,0,0,0-1.23.4,5.22,5.22,0,0,1-.22,1.36.57.57,0,0,1-.56.46.64.64,0,0,1-.52-.23,1,1,0,0,1-.18-.61A1.85,1.85,0,0,1,250,75a3.5,3.5,0,0,1,1.45-.88,6.53,6.53,0,0,1,2.12-.31,3.77,3.77,0,0,1,2.11.5,2.65,2.65,0,0,1,1.07,1.45,7.61,7.61,0,0,1,.31,2.37v3.66a.71.71,0,0,0,.16.55.64.64,0,0,0,.45.15,1.35,1.35,0,0,0,.64-.18,2,2,0,0,0,.54-.39.36.36,0,0,1,.28-.14.4.4,0,0,1,.31.15.53.53,0,0,1,.13.34.4.4,0,0,1-.12.29,2.77,2.77,0,0,1-.86.63,2.41,2.41,0,0,1-1,.23,1.71,1.71,0,0,1-1-.29A1.61,1.61,0,0,1,256,82a4.41,4.41,0,0,1-1.62,1.08,5.75,5.75,0,0,1-2.25.43,2.8,2.8,0,0,1-2-.72,2.58,2.58,0,0,1-.74-1.93,2.24,2.24,0,0,1,.77-1.84,4.26,4.26,0,0,1,1.91-.82c.75-.13,1.76-.24,3-.33l.85,0Zm0,3.53V78.59l-.48,0c-1.28.13-2.24.25-2.87.36a3.48,3.48,0,0,0-1.52.59,1.44,1.44,0,0,0-.56,1.24,1.61,1.61,0,0,0,.48,1.3,2,2,0,0,0,1.3.4,5.51,5.51,0,0,0,2-.39A4.48,4.48,0,0,0,255.94,81.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M264.3,76.43a2.16,2.16,0,0,1,1.08-2.05,5.41,5.41,0,0,1,2.69-.61,6.2,6.2,0,0,1,2,.31,2.62,2.62,0,0,1,1.3.76v-.43a.56.56,0,0,1,.14-.43.49.49,0,0,1,.35-.15.43.43,0,0,1,.34.15.56.56,0,0,1,.14.42l0,2.35a.5.5,0,0,1-.13.33.46.46,0,0,1-.34.11.36.36,0,0,1-.37-.22,2.56,2.56,0,0,1-.1-.78,2.08,2.08,0,0,0-1.2-1.1,5.74,5.74,0,0,0-2.16-.36c-1.66,0-2.48.51-2.48,1.52a1.21,1.21,0,0,0,.32.87,2.37,2.37,0,0,0,1.16.53l3,.6a3.44,3.44,0,0,1,1.75.81,2.38,2.38,0,0,1,.62,1.8,2.19,2.19,0,0,1-1,2,5.13,5.13,0,0,1-2.78.66,6.43,6.43,0,0,1-2.05-.32,3.71,3.71,0,0,1-1.59-1.07v.7a.5.5,0,0,1-.12.37.41.41,0,0,1-.3.12.52.52,0,0,1-.33-.12.45.45,0,0,1-.14-.33l0-2.65a.68.68,0,0,1,.13-.46.36.36,0,0,1,.29-.15.41.41,0,0,1,.31.12.76.76,0,0,1,.11.49,1.74,1.74,0,0,0,.48,1.19,3.13,3.13,0,0,0,1.29.85,5.26,5.26,0,0,0,1.82.3,4.15,4.15,0,0,0,2-.41,1.39,1.39,0,0,0,.71-1.28,1.43,1.43,0,0,0-.32-1,1.74,1.74,0,0,0-1.06-.51l-3.12-.61a3.78,3.78,0,0,1-1.82-.79A1.93,1.93,0,0,1,264.3,76.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M277.76,74.22h3.43c.32,0,.48.17.48.5a.41.41,0,0,1-.46.46H280l3,7,2.67-7h-1a.41.41,0,0,1-.46-.46c0-.33.16-.5.47-.5h3.11q.54,0,.54.48a.43.43,0,0,1-.49.48h-.93l-3.55,9.09a7.2,7.2,0,0,1-1.42,2.39,2.77,2.77,0,0,1-2.09.86.89.89,0,0,1-.62-.16.57.57,0,0,1-.17-.44c0-.38.26-.57.79-.57a2,2,0,0,0,.85-.2,2.61,2.61,0,0,0,.73-.54,2,2,0,0,0,.44-.66l.63-1.63c-.44-.92-.91-1.93-1.39-3s-.79-1.79-.93-2.08c-.68-1.56-1.13-2.56-1.34-3h-1.09c-.32,0-.48-.15-.48-.46S277.4,74.22,277.76,74.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M314.47,74.17v4a.71.71,0,0,1-.13.45.41.41,0,0,1-.32.15.42.42,0,0,1-.31-.13.53.53,0,0,1-.16-.37l-.15-1.74h-3.95V82.3h4.1a.54.54,0,0,1,.4.14.47.47,0,0,1,.14.35.48.48,0,0,1-.14.36.49.49,0,0,1-.39.14h-7.21a.6.6,0,0,1-.44-.15.46.46,0,0,1,0-.7.61.61,0,0,1,.42-.14h2V70.58h-1.59a.54.54,0,0,1-.41-.15.46.46,0,0,1-.15-.34.5.5,0,0,1,.16-.37.61.61,0,0,1,.43-.15h10.44a.68.68,0,0,1,.47.17.58.58,0,0,1,.19.46v3.17a.52.52,0,0,1-.14.38.48.48,0,0,1-.33.13.58.58,0,0,1-.34-.11.47.47,0,0,1-.16-.33l-.16-2.86h-7.29v5h3.95l.15-1.56a.69.69,0,0,1,.16-.39.43.43,0,0,1,.31-.14.42.42,0,0,1,.32.16A.77.77,0,0,1,314.47,74.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M321.36,78.63a5.13,5.13,0,0,1,.62-2.58,4.19,4.19,0,0,1,1.75-1.69,6,6,0,0,1,5.2,0,4.17,4.17,0,0,1,1.74,1.69,5.58,5.58,0,0,1,0,5.15,4.25,4.25,0,0,1-1.74,1.7,6,6,0,0,1-5.2,0A4.28,4.28,0,0,1,322,81.2,5.09,5.09,0,0,1,321.36,78.63Zm1.26,0a4.53,4.53,0,0,0,.44,2A3.28,3.28,0,0,0,324.34,82a4.27,4.27,0,0,0,4,0,3.22,3.22,0,0,0,1.28-1.38,4.88,4.88,0,0,0,0-4,3.22,3.22,0,0,0-1.28-1.38,4.19,4.19,0,0,0-4,0,3.28,3.28,0,0,0-1.28,1.38A4.51,4.51,0,0,0,322.62,78.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M335.89,78.63a5.24,5.24,0,0,1,.62-2.58,4.19,4.19,0,0,1,1.75-1.69,6,6,0,0,1,5.2,0,4.25,4.25,0,0,1,1.75,1.69,5.66,5.66,0,0,1,0,5.15,4.34,4.34,0,0,1-1.75,1.7,6,6,0,0,1-5.2,0,4.28,4.28,0,0,1-1.75-1.7A5.2,5.2,0,0,1,335.89,78.63Zm1.26,0a4.53,4.53,0,0,0,.44,2A3.28,3.28,0,0,0,338.87,82a4.27,4.27,0,0,0,4,0,3.22,3.22,0,0,0,1.28-1.38,4.88,4.88,0,0,0,0-4,3.22,3.22,0,0,0-1.28-1.38,4.19,4.19,0,0,0-4,0,3.28,3.28,0,0,0-1.28,1.38A4.51,4.51,0,0,0,337.15,78.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M354,75.18V80.9a1.41,1.41,0,0,0,.56,1.24,2.5,2.5,0,0,0,1.46.39,5.54,5.54,0,0,0,1.7-.28,5.3,5.3,0,0,0,1.45-.71.14.14,0,0,1,.13-.05.46.46,0,0,1,.33.2.6.6,0,0,1,.16.4.27.27,0,0,1-.06.17,2.44,2.44,0,0,1-.85.58,6.75,6.75,0,0,1-1.4.47,7.16,7.16,0,0,1-1.58.18,3.71,3.71,0,0,1-1.49-.3,2.76,2.76,0,0,1-1.12-.8,1.68,1.68,0,0,1-.41-1.08V75.18h-1.68a.54.54,0,0,1-.4-.15.52.52,0,0,1-.14-.35.44.44,0,0,1,.13-.32.49.49,0,0,1,.36-.14h1.73c0-1,0-1.67,0-2.09a2.92,2.92,0,0,1,.18-.94.51.51,0,0,1,.49-.29A.37.37,0,0,1,354,71a.81.81,0,0,1,.08.39v2.8h4.36a.4.4,0,0,1,.33.15.48.48,0,0,1,.13.33.45.45,0,0,1-.13.34.4.4,0,0,1-.34.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M366.7,69.47q.48,0,.48.45V75a5.23,5.23,0,0,1,1.48-.93,4.94,4.94,0,0,1,1.85-.31,4.43,4.43,0,0,1,2.35.62,4.2,4.2,0,0,1,1.54,1.74,5.63,5.63,0,0,1,.54,2.5,5.76,5.76,0,0,1-.53,2.52,4,4,0,0,1-1.52,1.72,4.26,4.26,0,0,1-2.34.62,4.89,4.89,0,0,1-1.93-.38,4.84,4.84,0,0,1-1.49-1,3.33,3.33,0,0,1-.08.83.46.46,0,0,1-.52.41.41.41,0,0,1-.35-.19,1.42,1.42,0,0,1-.13-.72V70.51l-1.5.09-.1,0h-.13a.49.49,0,0,1-.33-.13.42.42,0,0,1-.13-.32.47.47,0,0,1,.1-.3.42.42,0,0,1,.29-.18l2.21-.22Zm3.83,13.06a2.94,2.94,0,0,0,1.79-.53,3.27,3.27,0,0,0,1.12-1.41,5,5,0,0,0,.37-2,4.86,4.86,0,0,0-.39-2,3.32,3.32,0,0,0-1.14-1.42,3.18,3.18,0,0,0-1.84-.52,3.94,3.94,0,0,0-3.26,1.51v4.59a3.87,3.87,0,0,0,3.35,1.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M386.73,77.55a3.5,3.5,0,0,0-.54-2.1,2.14,2.14,0,0,0-1.84-.72,7.09,7.09,0,0,0-1.36.12,5.88,5.88,0,0,0-1.23.4,5.3,5.3,0,0,1-.21,1.36.59.59,0,0,1-.57.46.64.64,0,0,1-.52-.23,1,1,0,0,1-.18-.61A1.82,1.82,0,0,1,380.8,75a3.4,3.4,0,0,1,1.44-.88,6.53,6.53,0,0,1,2.12-.31,3.77,3.77,0,0,1,2.11.5,2.71,2.71,0,0,1,1.08,1.45,8,8,0,0,1,.3,2.37v3.66a.71.71,0,0,0,.16.55.64.64,0,0,0,.45.15,1.35,1.35,0,0,0,.64-.18,2,2,0,0,0,.54-.39.36.36,0,0,1,.28-.14.4.4,0,0,1,.31.15.53.53,0,0,1,.13.34.4.4,0,0,1-.12.29,2.77,2.77,0,0,1-.86.63,2.37,2.37,0,0,1-1,.23,1.72,1.72,0,0,1-1-.29,1.61,1.61,0,0,1-.55-1.12,4.46,4.46,0,0,1-1.61,1.08,5.83,5.83,0,0,1-2.26.43,2.8,2.8,0,0,1-2.05-.72,2.58,2.58,0,0,1-.74-1.93,2.24,2.24,0,0,1,.77-1.84,4.26,4.26,0,0,1,1.91-.82c.75-.13,1.77-.24,3-.33l.86,0Zm0,3.53V78.59l-.49,0c-1.28.13-2.24.25-2.87.36a3.53,3.53,0,0,0-1.52.59,1.47,1.47,0,0,0-.56,1.24,1.61,1.61,0,0,0,.48,1.3,2,2,0,0,0,1.3.4,5.51,5.51,0,0,0,2-.39A4.61,4.61,0,0,0,386.73,81.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M399.72,69.44a.5.5,0,0,1,.31.1.38.38,0,0,1,.11.28V82.33h4a.4.4,0,0,1,.33.15.52.52,0,0,1,.12.33.49.49,0,0,1-.12.34.41.41,0,0,1-.34.14h-9.38a.53.53,0,0,1-.4-.14.52.52,0,0,1-.14-.35.48.48,0,0,1,.13-.33.49.49,0,0,1,.36-.14H399V70.52l-4.14.33h-.08a.43.43,0,0,1-.35-.15.47.47,0,0,1-.13-.34.54.54,0,0,1,.09-.31.42.42,0,0,1,.28-.16l4.9-.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M414.25,69.44a.5.5,0,0,1,.31.1.34.34,0,0,1,.11.28V82.33h4a.4.4,0,0,1,.33.15.53.53,0,0,1,.13.33.49.49,0,0,1-.13.34.4.4,0,0,1-.34.14h-9.38a.53.53,0,0,1-.4-.14.52.52,0,0,1-.14-.35.53.53,0,0,1,.13-.33.5.5,0,0,1,.37-.14h4.32V70.52l-4.14.33h-.08a.43.43,0,0,1-.35-.15.47.47,0,0,1-.13-.34.54.54,0,0,1,.09-.31.42.42,0,0,1,.29-.16l4.89-.45Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-15",
  x: 21.37,
  y: 73.89,
  width: 150,
  height: 10
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 425.44 87.57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.89dbae14.svg";
export { ForwardRef as ReactComponent };